import { useQuery } from "@rocicorp/zero/react"

import { queries } from "@productlane/zero/queries"

import { MetaInfo } from "@/components/meta-info"
import { SettingsHeader } from "../settings-header"
import { PersonalEmailNotificationSection } from "./personal-email-notification-section"

export function NotificationEmailSettingsPage() {
	const [user] = useQuery(queries.currentUser())
	const [workspace] = useQuery(queries.currentWorkspace())

	if (!user) return null

	return (
		<>
			<MetaInfo title="Email notifications" />

			<SettingsHeader title="Email" subtitle="Pick what sends an email." />

			<PersonalEmailNotificationSection
				data={user}
				docsProposalCadence={workspace?.docsProposalCadence}
			/>
		</>
	)
}
